import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth-service/auth-service.service';

function exportListUrl(lookup: string): string {
  return `/api/xevprm/export/${lookup}/`;
}


@Injectable({
  providedIn: 'root'
})
export class ExportServiceComponent {

  constructor(private httpClient: HttpClient,
    private authService:AuthService
  ) { }

  get(type: string, model: any): Observable<Blob> {
    return this.getImpl<Blob>(exportListUrl(type),model,type);
  }

  private getImpl<ResultType>(url: string,model: any, type: string): Observable<Blob> {
    let headers = new HttpHeaders(
      {'Authorization': 'Bearer '+ this.authService.getAccessToken(), 'AuthSession': this.authService.getSessionToken()}
    );

    const formData = new FormData();

    if (model && model.attachments && model.attachments.attachment && model.attachments.attachment.length>0){
      // Files
      for (let i = 0; i < model.attachments.attachment.length; i++) {
        if ( model.attachments.attachment[i].file){
          model.attachments.attachment[i].filename = model.attachments.attachment[i].filename + this.getAttachmentType(model.attachments.attachment[i].filetype);
          formData.append("files",  model.attachments.attachment[i].file[0],  model.attachments.attachment[i].filename);
        }
      }
    }
    
    formData.append("message", new Blob(
      [ JSON.stringify(model) ],
      { type: "application/json" }
    ));

    //Added information not content in EvprmElement to RTF export
    if (type == "rtf") {
      formData.append("additionalInfo", new Blob(
        [JSON.stringify(model)],
        { type: "application/json" }
      ))
    }

    

    return this.httpClient.post(environment.apiUrl + url, formData,{headers:headers, responseType: 'blob'});
  }


 getAttachmentType(code: number){
  let type;
  switch(code){
    case 1:
      type = ".PDF";
    break;
    case 2:
      type = ".DOC";
    break;
    case 3:
      type = ".DOCX";
    break;
    case 4:
      type = ".XLS";
    break;
    case 5:
      type = ".XLSX";
    break;
  }

  return type;
 }

}
